import _ from 'lodash'
import { useRecordContext } from 'react-admin'
import StarIcon from '@mui/icons-material/Star'
import { RatingFieldProps } from './type'

export const RatingField: React.FC<RatingFieldProps> = (props) => {
  const {
    source,
    max = 5,
    size = 'small',
    activeColor = '#ffd700',
    inactiveColor = '#bdbdbd',
    className,
  } = props
  const record = useRecordContext()
  const rating = _.get(record, source)
  return (
    <div
      className={className}
      style={{
        display: 'flex',
      }}
    >
      {_.map([...Array(max)], (i, idx) => (
        <StarIcon
          key={idx}
          fontSize={size}
          style={{ color: rating - idx > 0 ? activeColor : inactiveColor }}
        />
      ))}
    </div>
  )
}
